<script lang="ts">var _a, _b, _c;
import CardBase from '../../../common/CardBase.svelte';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { Readable } from 'svelte/store';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import Select from 'svelte-select';
import TextInput from "../TextInput/TextInput.svelte";
import { t } from "../../../../../js/i18n";
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: isRequiredKey = (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.isRequiredKey;
$: key = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.key;
$: isRequired = isRequiredKey ? ($mergedParams || {})[isRequiredKey] : '';
let gender = '';
const handleChange = (e) => {
    gender = e.target.value;
    console.log('gender: ', gender);
    tabContext.setParam(key, gender);
};
$: placeholder = $t("Gender") + (isRequired === 'true' ? "*" : "");
</script>
    <CardBase {element}>
        <div class="gender-input-field-wrapper">
            <TextInput placeholder={placeholder} value={gender} onChange={handleChange} />
        </div>
    </CardBase>
    <style>.gender-input-field-wrapper {
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
}</style>